import "./howItWorksPage.scss";
import "../aboutPage/aboutPage.scss";
import FeatureExploration from "../../assets/nota-reimagined/exploration@2x.png";
import FeatureGuides from "../../assets/nota-reimagined/guide-chat.png";
import FeatureCrews from "../../assets/nota-reimagined/crews.png";
import AppStoreLink from "../../components/appStoreLink/appStoreLink";

const HowItWorksPage = () => {
  return (
    <div className="how-it-works-page about-page">
      <div className="how-it-works-page-content about-page-content">
        <div className="intro">
          <h1>
            How It Works
            <br />
            <span>Guides + Challenges + Crews</span>
          </h1>
        </div>
        <div className="features">
          <div className="feature">
            <p>1. Pick a topic and explore paths with insightful content.</p>
            <div className="feature-image">
              <img src={FeatureExploration} />
            </div>
          </div>
          <div className="feature">
            <div className="feature-image">
              <img src={FeatureGuides} />
            </div>
            <p>
              2. Take on challenges and discuss the content with interactive AI
              guides.
            </p>
          </div>
          <div className="feature">
            <p>3. Join a crew and read markers with friends.</p>
            <div className="feature-image">
              <img src={FeatureCrews} />
            </div>
          </div>
        </div>
        <p>
          Nota consists of interactive journeys, each focusing on specific
          topics to help you move beyond a current state and guide you closer to
          where you want to be. Each journey contains markers that unpack vital
          concepts in just a few minutes.
        </p>
        <p>
          At the end of each trail, you’ll face a challenge designed to help you
          apply what you’ve learned to your life, fostering real change over
          time. After completing a subject, you can discuss it with an AI mascot
          guide for deeper understanding or engage with your crew of friends for
          discussion. You can also customize your entire path by adding or
          removing different journeys.
        </p>
        <div className="cta">
          <strong>Download Nota today!</strong>
          <div className="button-wrap">
            <AppStoreLink type="ios" />
            <AppStoreLink type="android" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksPage;
